import * as React from 'react';
import {
    Typography, Select, MenuItem, FormControl, Autocomplete,
    DialogTitle, DialogContent,
    Dialog, Button, Box, DialogActions, TextField
} from '@mui/material';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import "../../PrivatePages/Preset/presetStyle.css"

const DropdownIcon = (props) => (
    <svg
        {...props}
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ pointerEvents: "none" }}
    >
        <path
            d="M4 6L8 10L12 6"
            stroke="#33584E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function HeaderMapping({ isMaping, setIsMaping, header, HandleConfirm }) {
    const units = [
        "Whole Numbers",
        "Hundreds",
        "Thousands",
        "Lakhs",
        "Crores",
    ];

    const [mapeedObj, setMapeedObj] = useState({
        branch: '',
        ledger_code: "",
        ledger_name: "",
        cy: "",
        py: "",
        tcomparative: "",
        tbAmount: ""
    });

    const [addColumnName, setAddColumnName] = useState("");
    const [showAddColumn, setShowAddColumn] = useState(false);

    const selectSx = {
        background: "#F4FAF5",
        borderRadius: "8px",
        height: "34px",
        fontSize: "15px",
        color: "#33584E",
        fontFamily: "'DM Sans', sans-serif",
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2E6D1',
            borderRadius: "8px",
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2E6D1',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C2E6D1',
        },
        '&:hover': {
            background: "#F4FAF5",
        },
        '&.Mui-focused': {
            background: "#F4FAF5",
        },
        '& .MuiSelect-select': {
            paddingTop: "7px",
            paddingBottom: "7px",
        },
    };

    const menuItemSx = {
        fontSize: "15px",
        color: "#33584E",
        fontFamily: "'DM Sans', sans-serif",
        '&:hover': {
            background: "#F4FAF5",
        },
        '&.Mui-selected': {
            background: "#F4FAF5",
            '&:hover': {
                background: "#e8f5ee",
            }
        }
    };

    const fields = [
        {
            label: "Name Of The Branch",
            required: false,
            value: mapeedObj.branch,
            onChange: (v) => setMapeedObj({ ...mapeedObj, branch: v }),
            options: header.headers,
            includeNone: true,
        },
        {
            label: "Ledger Code",
            required: true,
            value: mapeedObj.ledger_code,
            onChange: (v) => setMapeedObj({ ...mapeedObj, ledger_code: v }),
            options: header.headers,
            includeNone: false,
        },
        {
            label: "Ledger Name",
            required: true,
            value: mapeedObj.ledger_name,
            onChange: (v) => setMapeedObj({ ...mapeedObj, ledger_name: v }),
            options: header.headers,
            includeNone: false,
        },
        {
            label: "Current Year Net Balance Column",
            required: true,
            value: mapeedObj.cy,
            onChange: (v) => setMapeedObj({ ...mapeedObj, cy: v }),
            options: header.headers,
            includeNone: false,
        },
        {
            label: "Previous Year Net Balance Column",
            required: true,
            value: mapeedObj.py,
            onChange: (v) => setMapeedObj({ ...mapeedObj, py: v }),
            options: header.headers,
            includeNone: false,
        },
        {
            label: "Amount In Trial Balance",
            required: true,
            value: mapeedObj.tbAmount,
            onChange: (v) => setMapeedObj({ ...mapeedObj, tbAmount: v }),
            options: units,
            includeNone: false,
        },
        {
            label: "Comparative (Extra)",
            required: false,
            value: mapeedObj.tcomparative,
            onChange: (v) => setMapeedObj({ ...mapeedObj, tcomparative: v }),
            options: header.headers,
            includeNone: true,
        },
    ];

    const rows = [];
    for (let i = 0; i < fields.length; i += 2) {
        rows.push(fields.slice(i, i + 2));
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={isMaping}
                onClose={() => setIsMaping(false)}
                PaperProps={{
                    style: {
                        borderRadius: "16px",
                        padding: "0px",
                        maxWidth: "600px",
                        width: "100%",
                        fontFamily: "'DM Sans', sans-serif"
                    }
                }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pb: 2.5,
                        pt: 2.5,
                        px: 3,
                        borderBottom: "1px solid #eaeeed"
                    }}
                >
                    <span style={{ fontSize: "18px", fontWeight: 500, color: "#111111", fontFamily: "'DM Sans', sans-serif" }}>
                        Map Column headers
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: "15px",
                                color: "#2D8861",
                                fontWeight: 500,
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                fontFamily: "'DM Sans', sans-serif"
                            }}
                            onClick={() => setShowAddColumn(!showAddColumn)}
                        >
                            <AddIcon style={{ fontSize: "16px" }} />
                            Add Column
                        </span>
                        <CloseIcon
                            style={{ cursor: "pointer", color: "#555", fontSize: "20px" }}
                            onClick={() => setIsMaping(false)}
                        />
                    </div>
                </DialogTitle>

                <DialogContent sx={{ pt: 4, pb: 1, px: 3 }}>
                    <Box>
                        {rows.map((row, rowIdx) => (
                            <div
                                key={rowIdx}
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "14px",
                                    margin: "20px 0",
                                }}
                            >
                                {row.map((field, fieldIdx) => (
                                    <FormControl key={fieldIdx} fullWidth>
                                        <Typography
                                            sx={{
                                                fontSize: "12px",
                                                color: "#33584E",
                                                marginBottom: "5px",
                                                fontWeight: 500,
                                                display: "block",
                                                textAlign: "left",
                                                width: "100%",
                                                fontFamily: "'DM Sans', sans-serif",
                                            }}
                                        >
                                            {field.required && (
                                                <span style={{ color: "#2D8861", marginRight: "2px" }}>*</span>
                                            )}
                                            {field.label}
                                        </Typography>

                                        <Autocomplete
                                            value={field.value || null}
                                            onChange={(event, newValue) => field.onChange(newValue || "")}
                                            options={field.options || []}
                                            popupIcon={<DropdownIcon />}
                                            disableClearable={!field.includeNone}
                                            sx={{
                                                '& .MuiAutocomplete-popupIndicator': {
                                                    '&:hover': { background: 'transparent' }
                                                },
                                                '& .MuiAutocomplete-endAdornment': {
                                                    right: '4px'
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Select Column"
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '0px 30px 0px 8px !important',
                                                            background: "#F4FAF5",
                                                            borderRadius: "8px",
                                                            height: "34px",
                                                            fontFamily: "'DM Sans', sans-serif",
                                                            '& fieldset': { borderColor: '#C2E6D1' },
                                                            '&:hover fieldset': { borderColor: '#C2E6D1' },
                                                            '&.Mui-focused fieldset': { borderColor: '#C2E6D1' },
                                                        },
                                                        '& input': {
                                                            padding: '0px !important',
                                                            height: '100%',
                                                            fontSize: '15px',
                                                            color: '#33584E',
                                                            fontFamily: "'DM Sans', sans-serif",
                                                            '&::placeholder': {
                                                                color: "#A0B5AF",
                                                                opacity: 1,
                                                            }
                                                        }
                                                    }}
                                                />
                                            )}
                                            componentsProps={{
                                                paper: {
                                                    sx: {
                                                        borderRadius: "8px",
                                                        border: "1px solid #C2E6D1",
                                                        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
                                                        mt: "4px",
                                                        '& .MuiAutocomplete-listbox': {
                                                            padding: '4px 0',
                                                            '& .MuiAutocomplete-option': {
                                                                fontSize: "13px",
                                                                color: "#33584E",
                                                                fontFamily: "'DM Sans', sans-serif",
                                                                minHeight: "34px",
                                                                '&:hover': { background: "#f8f9f9" },
                                                                '&.Mui-focused': { background: "#f8f9f9" },
                                                                '&.Mui-focusVisible': { background: "#f8f9f9" },
                                                                '&[aria-selected="true"]': {
                                                                    background: "#f4faf5",
                                                                    '&:hover': { background: "#f8f9f9" },
                                                                    '&.Mui-focused': { background: "#f4faf5" },
                                                                    '&.Mui-focusVisible': { background: "#f4faf5" }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </FormControl>
                                ))}
                            </div>
                        ))}

                        {/* Add Column input */}
                        {showAddColumn && (
                            <div style={{ marginTop: "4px", marginBottom: "8px" }}>
                                <Typography
                                    sx={{
                                        fontSize: "13px",
                                        color: "#33584E",
                                        marginBottom: "5px",
                                        fontWeight: 500,
                                        display: "block",
                                        textAlign: "left",
                                        width: "100%",
                                        fontFamily: "'DM Sans', sans-serif",
                                    }}
                                >
                                    Enter Column Name
                                </Typography>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <TextField
                                        placeholder="Type something..."
                                        size="small"
                                        value={addColumnName}
                                        onChange={(e) => setAddColumnName(e.target.value)}
                                        sx={{
                                            width: "280px",
                                            borderRadius: "8px",
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: "8px",
                                                height: "34px",
                                                background: "#F4FAF5",
                                                '& fieldset': { borderColor: '#C2E6D1' },
                                                '&:hover fieldset': { borderColor: '#C2E6D1' },
                                                '&.Mui-focused fieldset': { borderColor: '#C2E6D1' },
                                                '& input': { fontSize: "13px", padding: "7px 14px", fontFamily: "'DM Sans', sans-serif" }
                                            }
                                        }}
                                    />
                                    <button
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                            background: "#F4FAF5",
                                            border: "1px solid #C2E6D1",
                                            borderRadius: "8px",
                                            padding: "5px 14px",
                                            cursor: "pointer",
                                            fontSize: "13px",
                                            color: "#2D8861",
                                            fontWeight: 600,
                                            fontFamily: "'DM Sans', sans-serif"
                                        }}
                                        onClick={() => {
                                            setShowAddColumn(false);
                                            setAddColumnName("");
                                        }}
                                    >
                                        <CheckCircleOutlineIcon style={{ fontSize: "15px" }} />
                                        Save
                                    </button>
                                </div>
                            </div>
                        )}
                    </Box>
                </DialogContent>

                {/* Footer */}
                <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2.5, pt: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={() => setIsMaping(false)}
                        sx={{
                            borderRadius: "8px",
                            border: "1px solid #C2E6D1",
                            color: "#33584E",
                            fontWeight: 600,
                            fontSize: "13px",
                            padding: "7px 24px",
                            textTransform: "none",
                            '&:hover': { border: "1px solid #C2E6D1", background: "#F4FAF5" }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => { HandleConfirm(mapeedObj); setIsMaping(false); }}
                        sx={{
                            borderRadius: "8px",
                            background: "#205A46",
                            color: "#ffffff",
                            fontWeight: 600,
                            fontSize: "13px",
                            padding: "7px 32px",
                            textTransform: "none",
                            boxShadow: "none",
                            '&:hover': { background: "#174a39", boxShadow: "none" }
                        }}
                    >
                        Finish
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}